import React from 'react'
import { Link } from 'gatsby'
import { ChevronRightIcon } from '@heroicons/react/24/outline'
import { SectionContainer } from '../SectionContainer'
import { LinkButton } from '../../common/menu/linkButton'
import { TitleHighlight } from '../../ui/typo/TitleHighlight'
import { HomeHeading } from './Heading'

export const FimsSection = () => {
  const steps = [
    {
      label: '#1 - Filtre la recherche sur tes critères',
    },
    {
      label: "#2 - Consulte les pages employeurs et offres d'emploi",
    },
    {
      label: '#3 - Postule aux meilleures opportunités',
    },
    {
      label: '#4 - Suis ta candidature sur ton espace',
    },
  ]

  return (
    <SectionContainer>
      <div className="order-last pr-10 space-y-8 md:order-first md:space-y-8 lg:space-y-8 xl:space-y-10">
        <HomeHeading additionalClasses="text-center md:text-left">
          Découvre les <TitleHighlight>cabinets</TitleHighlight>{' '}
          d&apos;expertise et de conseil qui te correspondent
        </HomeHeading>

        <div className="space-y-4">
          <p className="text-lg font-medium text-night">
            Tu préfères prendre contact avec les cabinets ? Nous avons rassemblé
            toutes les informations nécessaires pour te permettre de faire le
            bon choix.
          </p>
          <ul className="space-y-2 list-none md:space-y-4 lg:space-y-6">
            {steps.map(({ label }) => (
              <li key={label} className="flex items-center gap-2">
                <span className="font-thin text-night">{label}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="space-y-4 md:space-y-0 md:space-x-4 md:flex md:items-center">
          <LinkButton
            label="Découvrir les cabinets"
            href="/cabinets"
            isInverted
          />
          <Link to="/offres" className="flex items-center text-night">
            Postuler aux offres d&apos;emploi
            <ChevronRightIcon className="w-6 h-6 ml-1 text-night" />
          </Link>
        </div>
      </div>

      <div>
        <img
          className="object-cover w-full h-full"
          src="/FirmPlaceholder.webp"
          alt="Illustration de l'application Lamatch"
        />
      </div>
    </SectionContainer>
  )
}
